/**
 * Messages
 */

export const CLOSE = 'close';
